import {IMarlenkaOwner} from "./owner";
import {IMultilanguage, IOwnedEntity} from "@echo-nx/shared/common";

export interface IMAllergens extends IOwnedEntity<IMarlenkaOwner | string>, IMultilanguage {
  text: string,
  number: number,
  icon?: string
}
